import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";

import Index from "./pages/Index";
import CategoryPage from "./pages/CategoryPage";
import ProblemPage from "./pages/ProblemPage";
import HelpPage from "./pages/HelpPage";
import ProgressPage from "./pages/ProgressPage";
import { NIP19Page } from "./pages/NIP19Page";
import NotFound from "./pages/NotFound";

export function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/help" element={<HelpPage />} />
        <Route path="/progress" element={<ProgressPage />} />
        <Route path="/problems/:categoryId" element={<CategoryPage />} />
        <Route path="/problems/:categoryId/:problemId" element={<ProblemPage />} />
        {/* NIP-19 route for npub1, note1, naddr1, nevent1, nprofile1 */}
        <Route path="/:nip19" element={<NIP19Page />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
export default AppRouter;
